const wizardComponentsHelper = require('routes/contractsView/utilities/wizardComponenstHelper');
const inputs = require('routes/contractsView/fioc/inputs.js');

function buildSelfEmployed(prefix, authorized = false) {
    const inputsFioc = wizardComponentsHelper.replacePrefix(inputs.fioc, prefix);
    let grid = [
        [inputsFioc.cnae],
        [{
            id_component: 'condition-show',
            id: 'show',
            conditionType: 'single',
            conditionId1: prefix + 'fioc_cnae',
            conditionValue1: 1,
            item: inputsFioc.profession_cnae
        }],
        [{
            id_component: 'condition-show',
            id: 'show',
            conditionType: 'single',
            conditionId1: prefix + 'fioc_cnae',
            conditionValue1: 2,
            item: [
                inputsFioc.profession_category,
                {
                    id_component: 'condition-show',
                    id: 'show',
                    conditionType: 'ifPrevIsComplete',
                    conditionId1: prefix + 'profession_category',
                    item: inputsFioc.profession_current
                }
            ]
        }],
        [{
            id_component: 'condition-show',
            id: 'show',
            conditionType: 'ifPrevIsComplete',
            conditionIds: [
                prefix + 'profession_cnae',
                prefix + 'profession_current'
            ],
            item: inputsFioc.company_name
        }],
        [{
            id_component: 'condition-show',
            id: 'show',
            conditionType: 'ifPrevIsComplete',
            conditionId1: prefix + 'company_name',
            item: [inputsFioc.incomes_annual]
        }],
    ];

    if (!authorized) {
        grid = [
            ...grid,
        ];
    }

    return {
        id_component: 'condition-show',
        id: 'show',
        conditionType: 'single',
        conditionId1: prefix + 'fioc_ocupation',
        conditionValue1: 0,
        item: {
            id_component: 'fioc',
            id: prefix + 'fioc_selfemployed',
            exclude: [],
            grid
        }
    }
}

module.exports = buildSelfEmployed;